import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addPromoToCart, removePromoFromCart } from '../modules/computed_cart';

class PromoDropin extends Component {
  constructor(props) {
    super(props);
    this.state = { promo: null };
    this.addPromoToCart = this.addPromoToCart.bind(this);
  }

  handleChange( sKey, evt ) {
    let oActiveUpdate = this.state.promo;
    oActiveUpdate = evt.target.value;
    this.setState({ promo: oActiveUpdate });
  }

  addPromoToCart( evt ) {
    evt.preventDefault();
    let promoCode = this.state.promo;
    this.props.dispatch( addPromoToCart(promoCode) );
    if (this.refs.promo.value != null) this.refs.promo.value = promoCode.toUpperCase();
  }

  removePromoFromCart( evt ) {
    evt.preventDefault();
    this.state.promo = null;
    this.refs.promo.value = '';
    this.props.dispatch( removePromoFromCart() );
  }

  render() {
    let oPromo            = this.props.computedCart.promo;
    let oPromoMsg         = this.props.promoMessage;
  	let sPromoMsgClass    = ((oPromoMsg.type === 'error') ? 'errorMessage ' : 'successMessage ') + 'showing';
    let ePromoMessage     = oPromoMsg ? (
      <div className={sPromoMsgClass}>
        <p>{oPromoMsg.text}</p>
      </div>
      ) : '';

    return(
      <div className={"section " + (oPromoMsg ? oPromoMsg.type : '')} id="cart-promo">
        <h4 className="alt">Enter Promo Code</h4>
        <div>
          <form onSubmit={this.addPromoToCart.bind(this)} onReset={this.removePromoFromCart.bind(this)}>
    				<input
  		        type        = "text"
  		        onChange    = {this.handleChange.bind(this, 'promo')}
  		        placeholder = "Promo Code"
  		        maxLength   = "28"
              defaultValue= {oPromo ? oPromo.promo_code : ''}
              disabled    = {oPromo} // truthy
              ref         = "promo"
  		        name        = "promo-enter" />
            <button
              className = {"btn-tertiary" + ((oPromo) ? " showing" : " hidden")}
              type      = "reset">×</button>
    				<button type="submit" className={"btn-secondary" + ((oPromo) ? " hidden" : "")}>Apply</button>
    			</form>
        </div>
        <div>
        	{ePromoMessage}
        </div>
      </div>
    );
  }
}


function mapStateToProps(state){
    return {
      'customer': state.customer,
      'computedCart': state.computedCart,
      'promoMessage': state.promoMessage,
      'storeType': state.store.type,
      'promos': state.promos
    };
}

export default connect(mapStateToProps)(PromoDropin);


// WEBPACK FOOTER //
// ./src/components/PromoDropin.jsx